import type { AuthCopy } from "./auth-copy";
import { AuthForm } from "./auth-form";

export const SignIn = ({ copy }: { copy?: AuthCopy } = {}) => <AuthForm copy={copy} />;
